/**
 * Response DTO for an {@link ExerciseProgramMessage} ("Information für den
 * Patienten"). One program can carry many of these (history / Verlauf).
 */
export class ExerciseProgramMessageResponseDto {
    id;
    createdAt;
    message;
    exerciseProgramId;
    authorId;
}
//# sourceMappingURL=exercise-program-message-response.dto.js.map